import { HelpCircle, Menu, Search, X } from "lucide-react";
import { NotificationBell } from "@/components/NotificationBell";
import { UserMenu } from "@/components/UserMenu";
import { toggleMobileNav, useMobileNavOpen } from "@/lib/mobileNav";

export default function AppHeader() {
  const navOpen = useMobileNavOpen();
  return (
    <header className="app-header" data-testid="app-header">
      <button
        className="mobile-menu-button"
        type="button"
        aria-label={navOpen ? "Close navigation" : "Open navigation"}
        aria-expanded={navOpen}
        aria-controls="mobile-navigation"
        data-testid="mobile-menu-button"
        onClick={toggleMobileNav}
      >
        {navOpen ? <X size={20} aria-hidden="true" /> : <Menu size={20} aria-hidden="true" />}
      </button>
      <div className="header-search" data-testid="global-search">
        <Search size={18} aria-hidden="true" />
        <input
          data-testid="global-search-input"
          placeholder="Search TAGForce..."
          aria-label="Search TAGForce"
        />
        <kbd data-testid="global-search-shortcut">⌘ K</kbd>
      </div>
      <div className="header-actions">
        <button
          className="icon-button"
          type="button"
          aria-label="Help center"
          data-testid="help-center-button"
        >
          <HelpCircle size={19} />
        </button>
        <NotificationBell />
        <div className="header-divider" />
        <UserMenu />
      </div>
    </header>
  );
}
